var scope_0 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0f909bb19431ad2516f5b419391643db.js').default;
var scope_1 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2efc50c3976e10c8453d4cbbe74c47da.js').default;
var scope_2 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/312e856cd51e2b18996b6a07caa7a8fa.js').default;
var scope_3 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4dff3a51da7733c06d9362430ec14cd4.js').default;
var scope_4 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/50f76304967ece206043b2c1f2819791.js').default;
var scope_5 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/53b7dd4a70f04ac2d89978992ae5370e.js').default;
var scope_6 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5863fc3ebecdf58cf7aa8027e1d0894f.js').default;
var scope_7 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/60ac07ec0350583d42b209f2942b0a89.js').default;
var scope_8 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/84ed100d050ce54dbfc41067600a679a.js').default;
var scope_9 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/97813e0f340319dc458eecc4435a807f.js').default;
var scope_10 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a9ffc007a36cd5f480471af295449b2b.js').default;
var scope_11 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b0bc264e893447bbd25be9dad55c8ac5.js').default;
var scope_12 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c9d36228e7211a0c66a7b0eacec4d380.js').default;
var scope_13 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d82b897d991ae271b6a53fae859847e8.js').default;
var scope_14 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_15 = require('D:/Users/bruce111/w101/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee5516a51678003f910bc1becc25a0a3.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15 )
    